var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyHotels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1377.6 1224.5",
    style: {
      enableBackground: "new 0 0 1377.6 1224.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C0311;stroke:#1A1A1A;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#1A1A1A;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#1A1A1A;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#434189;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#1A1A1A;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.5,893.8c3.5-4.3,60.1-70.7,143.6-59.1c54.2,7.6,98.1,49.7,106.9,60.1c10.5-11.6,196.7-229.2,393-179.2 c21.7,5.5,78.9,20.1,127.3,71.3c65.6,69.4,68.3,156.9,68.2,181.3l-687.3,28.5L212.5,893.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,1086.2c-3.4-11.1-34.9-119.8,12.4-185.3c51.8-71.6,188.1-78.2,294.6,36.7 c28.6-43.7,82.9-114,170.4-165c148-86.3,383.4-32,382,193.4c88.7-38.8,253.2-1.4,290.8,89.6c32.6,79-123.2,52.8-213.2,49 L162.3,1086.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1098,1047.7c0,0,200-165.6,183.7-355"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1282.6,708.5c0,0-23.3-12.2-3.4-55.7C1297.8,668.2,1293.6,703.1,1282.6,708.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1282.6,748c0,0-2-35.9,47.2-32.7C1336.6,740.9,1299.6,751.4,1282.6,748z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1280.5,748.6c0,0-34.6,0-31.2-34.9C1274.9,712.4,1281.5,741.3,1280.5,748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1271.7,792.4c0,0,9.1-37.5,56.3-22.8C1319.5,790.7,1294.6,805,1271.7,792.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1271.7,792.4c0,0-40.5-7.8-39.8-44.6C1258.6,752.2,1274.4,778.3,1271.7,792.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1259.2,829.8c0,0,38.6-31,66.2-8.2C1298.2,848.8,1263.4,836.8,1259.2,829.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1236.8,873.9c0,0,32.2-29.5,73.3-8.8C1299.6,889.9,1248,890.6,1236.8,873.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1215.4,915.4c0,0,54.1-17.6,76.9,19.4C1283.1,949.1,1224.7,946.2,1215.4,915.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1180.4,961.4c0,0,42.6-31.5,94.5,3.2C1240.6,992.1,1191.8,980.7,1180.4,961.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1142.6,1004.8c0,0,42.5-25.9,89.3,5C1218.2,1031.4,1163.1,1037.5,1142.6,1004.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1142.6,1004.8c0,0-45.8-25.6-32.2-77.6C1135.3,928,1159.6,987.5,1142.6,1004.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1180.4,961.4c0,0-42.9-30.7-17.1-76.1C1186,899.1,1196.7,941.8,1180.4,961.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1214.5,915.6c0,0-41.2-23-22.2-65.8C1216.4,864.4,1219.1,902.3,1214.5,915.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1236.8,875.9c0,0-40.5-12.8-34.3-58.7C1236.8,823.8,1237.2,867.1,1236.8,875.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1257.5,829.8c0,0-47.1-5-40-48.2C1236.5,787,1254.7,806.7,1257.5,829.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M229.1,1068c0,0-158.2,72.9-134.8-60.9C38.7,1025.3-15.5,948.3,30.8,902c-36.4-19.8-39-38.5-10.4-60.9 s51,23.9,44.8,40.6c36.4-19.8,62.5-20.8,79.1,7.3s7.3,48.9,7.3,48.9s40.1-50.5,77.5-22.4S229.1,1068,229.1,1068z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,848.3c0,0,93.5,185.5,205.3,213.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.9,934.4c0,0,34.2,11.5,50.4,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.9,889.4c0,0,22.3,48.7,13.1,75.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.8,987.5c0,0,42,8,53.1-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.8,955.2c0,0,10.8,47.1-3.5,63.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.4,1045.3c0,0,52.6,10.5,58.1-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.2,970.9c0,0,23.1,55.2,7.6,82.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.7,1056.2c0,0-9.5-54.9,61.1-64.3c2.3-28.9,53.9-35.7,56.1,6c32.1,5,16.8,46.9,16.8,46.9L248.7,1056.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1239,1070.6c0,0,65.6-99.8,119.2-67.2c53.6,32.6-23.8,90.3-23.8,90.3L1239,1070.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1226.1,1070.6c0,0,65.6-99.8,119.2-67.2c53.6,32.6-23.8,90.3-23.8,90.3L1226.1,1070.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 738.7,
    cy: 1116,
    rx: 630,
    ry: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M633.3,425.3c0,0,88.1,45.3,145.8,15.4s74.7-92.9,74.7-92.9s33.5,2.3,35.1,30.4 c-10.9,49.6-59.1,140.8-148.3,147.4l-89.2,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M872.2,1063c0.8,6,2.5,10.2,6,11c14.4,3.1,162.8,22.3,170.1-2.6c0.3-1.2,0.4-2.4,0.1-3.6 c-7.1,3.9-14.9,6.3-23,6.9C973.4,1078.4,922.3,1071.2,872.2,1063z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M940,1015.6c-3.5,4.9-8.3,8.4-13.4,8.4c-16.3-0.9-37.2,7.3-51.8-0.2c-2,12.4-3.9,28.6-2.6,39.2 c50.2,8.3,101.2,15.4,153.2,11.7c8.1-0.6,15.9-3,23-6.9C1044.4,1049,973.7,1025.7,940,1015.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M926.6,1023.9c5.2,0,10-3.5,13.4-8.4c-10.6-3.2-17.6-5.1-17.6-5.1l-44.3-4.6c0,0-1.7,7.7-3.4,17.9 C889.4,1031.2,910.2,1023,926.6,1023.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.5,1152.4c0,0-17.3-6.2-23.2-38.9c-8.1-44.9-12.6-123.9-2.4-133.8c12.9-12.6,11.4-9.7,11.4-9.7l22.1,22.3 L534.5,1152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.6,975c-11.2-2.2-18.5,0.6-23.1,4.8c-7.5,6.8-8.3,17.4-8.3,17.4s-4.6,153.5,28.9,155.1 s34.7-70.4,34.7-70.4c0.4-3.4,0.8-6.8,1.2-10C579,1022,571.8,985.6,540.6,975z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M674.7,872.9c59.1-5.8,139.5-77.3,139.5-77.3s-14.7,77.3,56,199.5c5.8,39.4,63.6,18.7,63.6,18.7 s12.2-287-34.6-337.2c-42.4-45.5-271,53-271,53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M960.1,1008.6c0,0-38,28.2-24.5,33.6s39-31.7,49.9-24.7c10.9,6.9-35.2,24.7-20.5,29s17.4-22,31.7-18.9 s0,17.4,0,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.6,981.3c0,0-39.9-0.1-46.4,39.7l-1.4,12l19,8.5C540.7,1041.5,580.8,990.5,569.6,981.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M633.3,713.7l-86.6,3.2c0,0-133,134.4-16.2,265.5c7.3,8.1,16.7,13.5,24.6,19.8 c136.9,108.6,198,134.5,198,134.5 M553.7,1000.9c-20.9,0-25.5,37.1-25.5,37.1s248.5,240.4,330.9,125.6S644.2,834.8,644.2,834.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.9,777.4c0,0,99.3,0.8,140.3-20.3c37.2-19.2,48.4-32.6,49.5-53.5c-48.6,5.8-181.6,61.8-181.6,61.8 L504.9,777.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M624.8,420.8c-3.1,0-49.5-3.1-49.5-3.1s-85.8,36.3-99.7,74.2s-14.8,256.2,34,271.3 c58.4,18.1,190.9-23.7,185.1-59.6c0,0,7.1-123.8-3.8-196.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.2,362c9.9,6.3-19.2,42.9-36.1,59.4c14.7,46.4,62.4,41.9,62.4,41.9l21.7-53.3c0,0,40.2,23.2,55.7-6.2 s0.8-125.2-30.2-129.1S595.3,304,603.2,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M581.7,361.7c0,0,13.5,18.6,36.2,18.6s16.8-49,24.4-49s-5.8,24.7,3.5,24.5s0-28.1,10.8-29.1s29.4-0.5,32-18.6 c14.9,9.8,27.8,13.4,36,3.6s-3.6-35-19.6-26.3c1-23.2-14.4-41.8-29.9-24.2c-10.3-20.1-51.5-13.5-45.9,13.1 c-30.4,8.5-43.8,39-31.4,57C577.2,340.1,574.6,354.5,581.7,361.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1061.8,20.8C983.5-22.4,885.1,6.1,841.9,84.3c-40.2,72.9-18.5,164.4,50.1,211.5L726.6,593.4 c-3,5.4-1,12.2,4.3,15.1c0,0,0,0,0,0l7.6,4.2c5.4,3,12.2,1,15.1-4.4c0,0,0,0,0,0L919,310.8c81.9,35.7,177.3-1.8,213-83.7 C1165.4,150.5,1135,61.1,1061.8,20.8z M930.8,289.6c-4.8-2-9.5-4.2-14-6.7c-4.5-2.5-8.9-5.3-13.1-8.2 c-61.9-44.1-76.4-130-32.3-192c44.1-61.9,130-76.4,192-32.3s76.4,130,32.3,192C1058.5,294.5,990.1,314.2,930.8,289.6L930.8,289.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M718.8,574.7c0,0,34.7-28.8,40.7-21.1s-10.4,19.5-10.4,19.5s26.3,0.6,35.6-20.1s11.2-13.1,13.3-8.5 s-7.9,41.9-24,51.6s-47.7,13.3-47.7,13.3S716.4,580.7,718.8,574.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M475.6,491.9c0,0-86.6,195.6-24,212.6s283.7-92,283.7-92s6.3-42.5-22.3-46.4c-95.1,37.1-139.1,33-201.9,62.3 c0,0,11.3-11.4,17.1-48.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M501.1,886c0,0,69-10.8,68.8-63.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M552.3,1060c0,0-17-2.7-16.2,6s29.8,3.5,30.9,9.3s-10.3,13.7-20.6,14.3s-5.7,14.5,13.1,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M631.2,397.7c-0.1-0.8,19.9,12.3,19.9,12.3l-6.8,16.7C644.3,426.7,631.8,401.7,631.2,397.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 624.2,
    cy: 489.6,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 630.2,
    cy: 524.2,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 635.2,
    cy: 558.8,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 232.8,
    cy: 672.1,
    r: 29.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1119.4,
    cy: 857.8,
    r: 28.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1057.7,
    cy: 770.1,
    r: 28.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M902.5,304.8c0,0-23.4-6.8-28.8,0s-14.5,43.9-14.5,43.9l3,0.7l7.2-12.9c0,0,5.3-18.5,16.2-18.8 S903.9,310.9,902.5,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M889,372c0,0,25.7-17.4,32.6-34.2s-3.2-27.6-12.4-26.6s-23,13.5-20.7,24s1.3,28.2-2.3,34.7L889,372z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1128.2,635.7c0,6.7-5.4,12.1-12.1,12.1c-6.7,0-12.1-5.4-12.1-12.1c0-6.7,5.4-12.1,12.1-12.1 C1122.7,623.6,1128.1,629,1128.2,635.7C1128.2,635.7,1128.2,635.7,1128.2,635.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1074.6,585.6c23.5-18.9,57-18.9,80.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1087.7,601.9c15.8-12.7,38.4-12.7,54.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1061.4,569.2c31.2-25.1,75.6-25.1,106.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1013,105.9c0,0,15,3.6,22.1,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1041.6,105.9c0,0,13.8,13.6,16.1,42.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M556.2,426.6c0,0,9.8-19.1,19.7-14.5c27,29.3,36.4,51,45,51C596.2,472.3,559.9,451.8,556.2,426.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M626.4,463.4c0,0,15.4-36.7,16.6-36.7c9,2.4,10.9,9.5,9.6,14.5S632,463.6,626.4,463.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHotels);
export default __webpack_public_path__ + "static/media/emptyHotels.27d5a18a3ad19f0a217d86d63cc99996.svg";
export { ForwardRef as ReactComponent };